import { donationMetadataSerializer } from "@flow/common/types";
import * as Safe from "safe-portals";

export type GatewayData = Safe.TypeIn<typeof gatewayDataSerializer>;

/* For DB donate__action.gateway_data JSON */
export const gatewayDataSerializer = Safe.variant(
  "stripe",
  Safe.obj({
    payment_intent_id: Safe.str,
  }),
  "paypal",
  Safe.obj({
    // Uniquely identifies an order (initial request) for payment.
    order_id: Safe.str,
    // Uniquely identifies a capture (authorisation) of a one-off payment.
    transaction_id: Safe.optional(Safe.str),
    // Uniquely identifies a subscription (recurring payment).
    subscription_id: Safe.optional(Safe.str),
  }),
  "smartdebit",
  Safe.obj({
    reference_number: Safe.str,
    customerId: Safe.str,
  })
);

export type DonationAttempt = Safe.TypeIn<typeof donationAttemptSerializer>;

export const donationAttemptSerializer = Safe.obj({
  guid: Safe.uuid,
  action_guid: Safe.uuid,
  variant_idx: Safe.int,
  personal_data_guid: Safe.uuid,
  gateway_data: gatewayDataSerializer,
  status: Safe.oneOf("pending", "success", "failed"),
  amount: Safe.float,
  metadata: Safe.optional(donationMetadataSerializer),
  hide_donation: Safe.bool,
  currency: Safe.str,
  frequency: Safe.oneOf("once", "weekly", "monthly", "yearly"),
  start_date: Safe.dateIso,
  created_at: Safe.dateIso,
});

export interface BankAccount {
  sort_code: string;
  account_number: string;
  account_name: string | undefined;
}

export const bankAccountSerializer: Safe.Type<BankAccount> = Safe.obj({
  sort_code: Safe.str,
  account_number: Safe.str,
  account_name: Safe.optional(Safe.str),
});

// Might need to rename this
export interface SmartDebitParams {
  amount: number;
  referenceNumber: string;
  customerId: string;
}

export const smartDebitParamsSerializer: Safe.Type<SmartDebitParams> = Safe.obj({
  amount: Safe.int,
  referenceNumber: Safe.str,
  customerId: Safe.str,
});

export interface SmartDebitDDI {
  email_address: string;
  first_name: string;
  last_name: string;
  frequency_type: string;
  reference_number: string;
  default_amount: number;
  start_date: string;
  service_user: { pslid: string };
}

export const smartDebitDDISerializer: Safe.Type<SmartDebitDDI> = Safe.obj({
  email_address: Safe.str,
  first_name: Safe.str,
  last_name: Safe.str,
  frequency_type: Safe.str,
  reference_number: Safe.str,
  default_amount: Safe.float,
  start_date: Safe.str,
  service_user: Safe.obj({ pslid: Safe.str }),
});

export const donateSettingsSerializer = Safe.obj({
  one_off_thank_you_email_template: Safe.str,
  regular_thank_you_email_template: Safe.str,
});

export type DonateSettings = Safe.TypeIn<typeof donateSettingsSerializer>;

export const recentDontionSerializer = Safe.obj({
  name: Safe.str,
  amount: Safe.float,
  currency: Safe.str,
  created_at: Safe.dateIso,
});
export type RecentDontion = Safe.TypeIn<typeof recentDontionSerializer>;

// Breakdown Types for donation tracking.
export enum DonationTrackingType {
  ALL = "all",
  ONE_OFF = "oneoff",
  REGULAR = "regular",
}
